import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";
import {
  activeLinkStyles,
  navLinkStyles,
} from "../GameHeader/Nav/NavItem/NavItem.css";

const sharedPseudoStyles = {
  content: "",
  position: "absolute" as const, // Needed to stop typescript error
  bottom: 0,
  height: 4,
  backgroundColor: vars.colors.onSurface,
};

export const activeSubNavLinkStyles = style([
  activeLinkStyles,
  {
    fontFamily: vars.fonts.bold,
    "::before": {
      ...sharedPseudoStyles,
      insetInlineStart: 0,
      width: "50%",
    },
    "::after": {
      ...sharedPseudoStyles,
      insetInlineEnd: 0,
      width: "50%",
    },
  },
]);

export const subNavLinkStyles = style([
  navLinkStyles,
  {
    color: vars.colors.onSurface,
    selectors: {
      "&::before, &::after": {
        ...sharedPseudoStyles,
      },
    },
  },
]);
